import React from 'react';
import { connect } from 'react-redux';
import { addNewAccountAdmin, fetchAccountAdmin } from '../../actions/accountAdmins';
import Logger from '../../util/Logger';
import './AccountAdministrators.css';
import User from '../../models/User';
import Admin from '../../models/User';
import _ from 'lodash';
import AccountAdministratorListItem from './AccountAdministratorListItem';
import { StringUtils } from '../../util/StringUtils';
import { handleEmailErrorsWithDialog, handleError, handleErrorWithDialog } from '../../util/Errors';
import { PulseLoader } from 'react-spinners';
import { showDialog } from '../../actions/dialog';
import { UserSorts } from './UserSorts';
import Tenant from '../../models/Tenant';
import { arrowDownIcon, arrowUpIcon, PAGE_LINK_ADMIN_ERROR } from '../../constants';
import { NavigationUtils } from '../../util/NavigationUtils';
import LoadingAndPulse from '../shared/LoadingAndPulse';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import { EnterpriseSettings } from '../../analytics/EnterpriseSettings';
import { TrackingAnalytics } from '../../analytics/TrackingAnalytics';

class AccountAdministrators extends React.Component {

  handleEmailChanged = ($event) => {
    const allEmails = $event.target.value;

    this.setState({
      emailString: allEmails
    });
  };

  handleEmailEntryEnded = () => {
    Logger.info(`Email entry complete: ${this.state.emailString}`);
  };

  handleAddButtonClick = ($event) => {
    // Don't submit
    $event.preventDefault();

    if (this.isAddDisabled()) {
      // Do nothing
      return;
    }

    // Split the string into a list
    const emails = StringUtils.stringToList(this.state.emailString);

    if (emails && emails.length > 0) {
      const { user, addNewAccountAdmin } = this.props;
      EnterpriseSettings.addAdmin();
      addNewAccountAdmin(Tenant.getId(User.getTenant(user)), emails);
    }
  };
  showErrorIfSelfRemoved = (oldAdmins) => {
    const { user, admins } = this.props;
    // We aren't going to stop them but we will block them afterwards.
    if (admins !== oldAdmins) {
      const oldContainsSelf = _.map(oldAdmins, a => User.getId(a)).indexOf(User.getId(user)) !== -1;
      const newMissingSelf = _.map(admins, a => User.getId(a)).indexOf(User.getId(user)) === -1;
      if (oldContainsSelf && newMissingSelf) {
        Logger.info('Old list contained self and new list does not - admin rights dropped');
        NavigationUtils.backToPopin();
      }
    }
  };
  isAddDisabled = () => {
    const { addLoading } = this.props;
    const { emailString } = this.state;
    return addLoading || !emailString || emailString.length === 0;
  };

  constructor (props) {
    super(props);

    const { user } = this.props;
    if (!user) {
      Logger.assert('Missing user in AccountAdministrators component');
    }

    this.state = {
      emailString: ''
    };
  }

  componentDidMount () {
    this.fetchAccountAdministrators();
  }

  fetchAccountAdministrators = () => {
    const { user, fetchAccountAdmin } = this.props;
    fetchAccountAdmin(Tenant.getId(User.getTenant(user)));
  };

  componentDidUpdate (prevProps) {
    const { adminError, addError, addErrors, removeError, admins } = this.props;

    this.showErrorIfSelfRemoved(prevProps.admins);
    handleError(adminError, prevProps.adminError);
    handleErrorWithDialog(removeError, prevProps.removeError, 'Unable to remove Administrator');

    handleErrorWithDialog(addError, prevProps.addError, 'Unable to add Administrators', {
      onHelpLinkClicked: EnterpriseSettings.whyAddAdminError,
      helpLink: PAGE_LINK_ADMIN_ERROR
    });

    handleEmailErrorsWithDialog(addErrors, prevProps.addErrors, 'Unable to add Administrators', {
      onHelpLinkClicked: EnterpriseSettings.whyAddAdminError,
      helpLink: PAGE_LINK_ADMIN_ERROR
    });

    TrackingAnalytics.handleInvalidEmails(prevProps.addErrors, addErrors,
      EnterpriseSettings.newAdminsRejected);

    if (!_.isEqual(admins, prevProps.admins)) {
      // Admins have updated, clear the text box
      this.setState({ emailString: '' });
    }
  }

  render () {
    const { admins, adminError, loading, addLoading } = this.props;
    const { emailString } = this.state;
    return (
      <div className="card min-height-card card-account-admin">
        <div className="row no-gutters mb-3">
          <div className="text-title my-auto text-uppercase">
            Account Administrators ({ admins ? admins.length : 0 })
          </div>
        </div>

        <div className="row email-addresses no-gutters">
          <form
            name="adminEmails"
            className="col-lg-9"
            onSubmit={ this.handleAddButtonClick }>
            <input
              type="text"
              className="pop-input col no-gutters pop-form-control"
              placeholder="Enter email addresses..."
              value={ emailString }
              onBlur={ this.handleEmailEntryEnded }
              onChange={ this.handleEmailChanged } />
          </form>
          <div className="col-lg-2 clearfix">
            <button
              type="button"
              className="btn pop-btn float-right"
              disabled={ this.isAddDisabled() }
              onClick={ this.handleAddButtonClick }>
              { addLoading
                ? <PulseLoader color="#FFFFFF" size={ 10 } />
                : `Add`
              }
            </button>
          </div>
          <div className="col-lg-1" />
        </div>

        <div className="row no-gutters">
          <AccountAdministratorList
            admins={ admins }
            error={ adminError }
            loading={ loading }
            refresh={ this.fetchAccountAdministrators } />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    admins: state.accountAdmins.admins,
    loading: state.accountAdmins.loading,
    adminError: state.accountAdmins.error,
    addLoading: state.accountAdmins.addLoading,
    addErrors: state.accountAdmins.addErrors || [],
    addError: state.accountAdmins.addError,
    removeError: state.accountAdmins.removeError
  };
};

export default connect(mapStateToProps, {
  fetchAccountAdmin,
  addNewAccountAdmin,
  showDialog
})(AccountAdministrators);

const Sorts = {
  EMAIL_ASCENDING: 'email',
  EMAIL_DESCENDING: 'email_reverse',
  DATE_ASCENDING: 'date',
  DATE_DESCENDING: 'date_reverse',
  ROLE_ASCENDING: 'role',
  ROLE_DESCENDING: 'role_reverse',
  NAME_ASCENDING: 'name',
  NAME_DESCENDING: 'name_reverse'
};

class AccountAdministratorList extends React.Component {

  getSortedAdminList = (admins) => {
    switch (this.state.activeSort) {
      case Sorts.EMAIL_ASCENDING:
        return UserSorts.copySortedByEmail(admins);
      case Sorts.EMAIL_DESCENDING:
        return UserSorts.copySortedByEmail(admins, true);
      case Sorts.DATE_ASCENDING:
        return UserSorts.copySortedByAddedDate(admins);
      case Sorts.DATE_DESCENDING:
        return UserSorts.copySortedByAddedDate(admins, true);
      case Sorts.ROLE_ASCENDING:
        return UserSorts.copySortedByRole(admins);
      case Sorts.ROLE_DESCENDING:
        return UserSorts.copySortedByRole(admins, true);
      case Sorts.NAME_ASCENDING:
        return UserSorts.copySortedByName(admins);
      case Sorts.NAME_DESCENDING:
        return UserSorts.copySortedByName(admins, true);
      default:
        Logger.assert('Could not return sorted admin list. Invalid sort: ', this.state.activeSort);
    }
  };
  handleSortByName = ($event) => {
    $event.preventDefault();
    const newSort = !this.state.nameSortReversed;
    EnterpriseSettings.sortsAdminsByName();
    this.setState({
      nameSortReversed: newSort,
      activeSort: newSort ? Sorts.NAME_DESCENDING : Sorts.NAME_ASCENDING
    });
  };
  handleSortByEmail = ($event) => {
    $event.preventDefault();
    const newSort = !this.state.emailSortReversed;
    EnterpriseSettings.sortAdminsByEmail();
    this.setState({
      emailSortReversed: newSort,
      activeSort: newSort ? Sorts.EMAIL_DESCENDING : Sorts.EMAIL_ASCENDING
    });
  };
  handleSortByAdded = ($event) => {
    $event.preventDefault();
    const newSort = !this.state.addedSortReversed;
    EnterpriseSettings.sortAdminsByDateAdded();
    this.setState({
      addedSortReversed: newSort,
      activeSort: newSort ? Sorts.DATE_DESCENDING : Sorts.DATE_ASCENDING
    });
  };
  handleSortByRole = ($event) => {
    $event.preventDefault();
    const newSort = !this.state.roleSortReversed;
    EnterpriseSettings.sortAdminsByRole();
    this.setState({
      roleSortReversed: newSort,
      activeSort: newSort ? Sorts.ROLE_DESCENDING : Sorts.ROLE_ASCENDING
    });
  };

  constructor (props) {
    super(props);

    this.state = {
      nameSortReversed: false,
      emailSortReversed: false,
      addedSortReversed: false,
      roleSortReversed: false,
      activeSort: Sorts.NAME_ASCENDING
    };
  }

  render () {
    const { user, admins, error, loading, refresh } = this.props;
    const sortedAdmins = this.getSortedAdminList(admins);
    const isNameSortActive = (
      this.state.activeSort === Sorts.NAME_ASCENDING ||
      this.state.activeSort === Sorts.NAME_DESCENDING
    );
    const isEmailSortActive = (
      this.state.activeSort === Sorts.EMAIL_ASCENDING ||
      this.state.activeSort === Sorts.EMAIL_DESCENDING
    );
    const isRoleSortActive = (
      this.state.activeSort === Sorts.ROLE_ASCENDING ||
      this.state.activeSort === Sorts.ROLE_DESCENDING
    );
    const isDateSortActive = (
      this.state.activeSort === Sorts.DATE_ASCENDING ||
      this.state.activeSort === Sorts.DATE_DESCENDING
    );

    return (
      <div className="col no-gutters">

        <div className="row pop-list-header admin-list-item font-size-md">
          <div className="name font-weight-semibold">
            <span className="clickable" onClick={ this.handleSortByName }>Name</span>
            <i
              onClick={ this.handleSortByName }
              className={ `material-icons clickable ${isNameSortActive
                ? 'enabled-icon'
                : 'disabled-icon'}` }>
              { this.state.nameSortReversed ? arrowUpIcon : arrowDownIcon }
            </i>
          </div>
          <div className="email font-weight-semibold">
            <span className="clickable" onClick={ this.handleSortByEmail }>Email</span>
            <i
              onClick={ this.handleSortByEmail }
              className={ `material-icons clickable ${isEmailSortActive
                ? 'enabled-icon'
                : 'disabled-icon'}` }>
              { this.state.emailSortReversed ? arrowUpIcon : arrowDownIcon }
            </i>
          </div>

          <div className="role font-weight-semibold">
            <span className="clickable" onClick={ this.handleSortByRole }>Role</span>
            <i
              onClick={ this.handleSortByRole }
              className={ `material-icons clickable ${isRoleSortActive
                ? 'enabled-icon'
                : 'disabled-icon'}` }>
              { this.state.roleSortReversed ? arrowUpIcon : arrowDownIcon }
            </i>
          </div>

          <div className="added font-weight-semibold">
            <span className="clickable" onClick={ this.handleSortByAdded }>Added</span>
            <i
              onClick={ this.handleSortByAdded }
              className={ `m-auto material-icons clickable ${isDateSortActive
                ? 'enabled-icon'
                : 'disabled-icon'}` }>
              { this.state.addedSortReversed ? arrowUpIcon : arrowDownIcon }
            </i>
          </div>

          <div className="remove font-weight-semibold">
            Remove
          </div>
        </div>

        { error
          ? (
            <div className="admin-list">
              <ErrorAndRefresh
                error="Failed to load Account Administrators"
                onRefresh={ refresh } />
            </div>
          )
          : loading
            ? (
              <div className="admin-list">
                <LoadingAndPulse
                  size={ 20 }
                  color="#3D9AE2"
                  whatIsLoading="Account Administrators" />
              </div>
            )
            : sortedAdmins ? (
              <div className="pop-list-container">
                <div className="col admin-list">
                  { sortedAdmins.map(a =>
                    <AccountAdministratorListItem
                      key={ Admin.getId(a) }
                      user={ user }
                      admin={ a } />
                  ) }
                </div>
              </div>
            ) : <div className="admin-list">No Account Administrators.</div>
        }
      </div>
    );
  }
}
